import styled from 'styled-components'

export const ContactCardContainer = styled.div`

color:${(props)=> props.textColor};

.btn-submit{
    padding: 10px 20px;
    width: 154px;
    height: 44px;
    background: none;
    border: 1px solid #295C7A;
    border-radius: 5px;
    border-color: ${(props)=> props.textColor};
    color: #295C7A;
    color:${(props)=> props.textColor};
    font-size: 14px;
    font-weight:700;
}

background-color:${(props)=> props.backgroundColor}

`











